import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=433d44dd&"
import script from "./CampaignDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports